import React, { PureComponent } from 'react';
import KickImage from 'Reuseables/KickImage';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SellerSuccess from '../../../../images/seller-registration-success.png';
import { doRefreshToken, doFetchProfile } from '../../../../actions/authAction';
import { Col } from 'reactstrap';
import Spinner from './SpinnerCustom';

class ProgressVerify extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.doRefreshToken();
  }

  render() {
    return (
      <div className="success-regist-sell-request">
        <div className="modal-success">
          <KickImage src={SellerSuccess} alt="..." />
          <p>You are now a seller!</p>
          <p>Your account has been verified successfully.</p>
          <p>You can start selling your product.</p>
          <button
            onClick={async () => {
              await this.props.fetchProfile();
              this.props.history.push('/sell-request');
            }}
          >
            <p>Start Selling</p>
          </button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  doRefreshToken: () => dispatch(doRefreshToken()),
  fetchProfile: () => dispatch(doFetchProfile()),
});

export default connect(null, mapDispatchToProps)(withRouter(ProgressVerify));
